import { FaPlus } from "react-icons/fa";

export function XPPlusIcon({ className }: { className?: string }) {
    return <FaPlus className={className} />
}